import { v4 as uuidv4 } from 'uuid';

import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IRiskCategory248 } from 'APIPackage/DictionariesModule/interfaces/IRiskCategory248';

import { IKnmErknmFormObject } from '../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormObject';

export function addObject(
  watchOnly: boolean,
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  push: ((...args: any[]) => any) | undefined,
  fieldName: string,
  lowRisk?: IDictionarySelectOption<IRiskCategory248>,
) {
  if (!watchOnly && push) {
    const addingObject: IKnmErknmFormObject = {
      address: undefined,
      addressFns: undefined,
      autocomplete: undefined,
      dangerClass: undefined,
      dateCreate: undefined,
      ervkId: undefined,
      ervkNumber: undefined,
      cosId: undefined,
      cosVersion: undefined,
      fiasRegion: undefined,
      geolocation: undefined,
      guid: undefined,
      houseGuid: undefined,
      inspectionResults: undefined,
      isErrorFiasValue: undefined,
      isNew: true,
      listId: uuidv4(),
      manualAddress: undefined,
      name: undefined,
      notInFIAS: undefined,
      objectKind: undefined,
      objectSubKind: undefined,
      objectType: undefined,
      organizationErvkId: undefined,
      region: undefined,
      regionName: undefined,
      riskCategory: lowRisk,
      roomGuid: undefined,
      steadGuid: undefined,
      streetGuid: undefined,
      updating: undefined,
    };

    push(fieldName, addingObject);
  }
}
